import type { ComponentSingleStyleConfig } from '@chakra-ui/theme'

const Tag: ComponentSingleStyleConfig = {
  defaultProps: {
    variant: 'solid',
  },
}

export default Tag
